import { Dropdown } from "Components/Shared/Inputs/Form/Dropdown";
import type { TerminalContractForm } from "Components/Shared/Merchant/Products/TerminalContracts/TerminalContractForm";
import type { MerchantAppProductDto } from "Infrastructure/Api/Api";
import type { Control, FieldPath } from "react-hook-form";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Components.Merchant.TerminalContracts;

type Props = {
  name: FieldPath<TerminalContractForm>;
  control: Control<TerminalContractForm>;
  merchantProducts: Array<MerchantAppProductDto>;
};

export const TerminalContractTypeDropdown = ({
  control,
  name,
  merchantProducts,
}: Props) => {
  const { t } = useResource();

  // Orbit L and SoftPOS share the COMGATE contract type: one entry per type.
  const codeList = merchantProducts
    .filter(({ productDto }) => !!productDto.terminalContractType)
    .filter(
      ({ productDto }, index, all) =>
        all.findIndex(
          (other) =>
            other.productDto.terminalContractType ===
            productDto.terminalContractType,
        ) === index,
    )
    .map(({ productDto: { terminalContractType } }) => ({
      // biome-ignore lint/style/noNonNullAssertion: null and undefined filtered out at this point
      code: terminalContractType!,
      // biome-ignore lint/style/noNonNullAssertion: null and undefined filtered out at this point
      name: t(COMPONENT_RESOURCES.ProductType[terminalContractType!]),
    }));

  return (
    <Dropdown
      label="Produkt"
      name={name}
      control={control}
      codeList={codeList}
    />
  );
};
